module.exports = __webpack_public_path__ + "static/img/colorpoptitle.8124ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/colorpop/colorpoptitle.png
// module id = 3C0t
// module chunks = 1